const initialState = null;

const OrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ORDERS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'GET_ORDER_SUCCESS':
    case 'UPDATE_ORDER_SUCCESS':
      return {
        ...state,
        loading: false,
        currentOrder: action.payload,
      };

    case 'FETCH_ORDERS_SUCCESS':
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case 'FETCH_ORDERS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default OrderReducer;
